import axios from 'axios';
import { USER_HISAB_KITAB_LIST, USER_LIST } from '../../constant/API constant';

export const UserList = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${USER_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};
export const UserHisabList = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${USER_HISAB_KITAB_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const CreateUser = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${USER_HISAB_KITAB_LIST}/create`, formData, {
    headers: { Authorization: jwt_token }
  });
};

export const UpdateUser = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.put(`${process.env.REACT_APP_API_URL}${USER_HISAB_KITAB_LIST}/`, formData, {
    headers: { Authorization: jwt_token }
  });
};

export const UserDetail = (userId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${USER_HISAB_KITAB_LIST}/detail`, {
    headers: { Authorization: jwt_token },
    params: { userId }
  });
};

export const DeleteUser = (userId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(`${process.env.REACT_APP_API_URL}${USER_HISAB_KITAB_LIST}/`, {
    headers: { Authorization: jwt_token },
    params: { userId }
  });
};

export const ChangeUserStatus = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.patch(`${process.env.REACT_APP_API_URL}${USER_HISAB_KITAB_LIST}/status`, formData, {
    headers: { Authorization: jwt_token }
  });
};
